import { useScrollTop } from 'hooks';
import PropType from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PageNotFound = ({ history }) => {
  const { t } = useTranslation();
  useScrollTop();

  return (
    <div className="page-not-found">
      <h1>{t('errorMessage4')}</h1>
      <br />
      <button className="button" onClick={history.goBack} type="button">
        {t('errorButtonBack')}
      </button>
    </div>
  );
};

PageNotFound.propTypes = {
  history: PropType.shape({
    goBack: PropType.func
  }).isRequired
};

export default PageNotFound;
